import { Stack } from '@mui/material';

import DeletePollSkeleton from '../DeletePoll/skeleton';
import EditPublishPreferencesSkeleton from '../EditPublishPreferences/skeleton';
import PublishPollSkeleton from '../PublishPoll/skeleton';

const PollActionsSkeleton = () => {
  return (
    /**
     * gap is not present in component, but we use gap in skeleton because
     * having gap in skeleton will look better.
     * Actual buttons are of variant text, so not having gap will also make it look fine
     */
    <Stack direction="row" alignItems="center" gap={0.5}>
      <DeletePollSkeleton />
      <EditPublishPreferencesSkeleton />
      <PublishPollSkeleton />
    </Stack>
  );
};

export default PollActionsSkeleton;
